// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoriesBar_container__c75m8","link":"CategoriesBar_link__VPt5v","isActive":"CategoriesBar_isActive__sF6RG","mobileSpacer":"CategoriesBar_mobileSpacer__4ZO3v"};